import ReturnedAppConfig from './returnedAppConfig';

const ReturnedProductsAppConfig = [ReturnedAppConfig];

export default ReturnedProductsAppConfig;
